export default "__VITE_ASSET__a18509b3__"